import RadioGroup from "designSystem/components/radio/RadioGroup";
import { FormField, Text } from "designSystem/index";
import { black } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { REQUIRED_LABEL } from "../snapshotUtils";

const ImageType = observer(() => {
	const store = useSnapshotTemplateStore();
	const { imageTypeOptions, imageType, setImageType } = store;
	
	return (
		<FormField
			control={(
				<RadioGroup							
					onChange={setImageType}
					options={imageTypeOptions}
					value={imageType}
				/>
			)}
			fullWidth
			label={<Text bold res="ImageType" />}
			labelPlacement="top"
			required
			sx={{
				...REQUIRED_LABEL,
				width: "fit-content",
				alignItems: "flex-start",
				"& .MuiTypography-root":{
					color: black[100],
				},
			}}
		/>
	);
});

export default ImageType;
